import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Solution technique appropriée pour les ResizeObserver
// Patch global du ResizeObserver pour gérer les loops de manière appropriée
if (window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  
  window.ResizeObserver = function(callback) {
    let frameId = null;
    let isScheduled = false;
    
    const safeCallback = (entries, observer) => {
      // Éviter les appels multiples dans le même frame
      if (isScheduled) return;
      
      isScheduled = true;
      
      // Différer l'exécution au prochain frame
      frameId = requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (error) {
          // Ignorer seulement les erreurs ResizeObserver, pas les autres
          if (!error.message || !error.message.includes('ResizeObserver')) {
            console.error('ResizeObserver callback error:', error);
          }
        } finally {
          isScheduled = false;
          frameId = null;
        }
      });
    };
    
    const observer = new OriginalResizeObserver(safeCallback);
    
    // Override disconnect pour cleanup le frame si nécessaire
    const originalDisconnect = observer.disconnect.bind(observer);
    observer.disconnect = () => {
      if (frameId) {
        cancelAnimationFrame(frameId);
        frameId = null;
        isScheduled = false;
      }
      originalDisconnect();
    };
    
    return observer;
  };
  
  // Préserver le prototype original
  window.ResizeObserver.prototype = OriginalResizeObserver.prototype;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
